<template>
  <!-- 普本院校管理 -->
  <el-button-group>
    <el-button type="primary" size="large" @click="addFnc($event)"
      ><el-icon><Plus /></el-icon>添加普本院校</el-button
    >
    <el-tooltip placement="top">
      <template #content>选择相应[普本院校]数据动态更新PC端[院校内容]页</template>
      <el-button type="primary" size="large" @click="releaseFnc($event)"
        ><el-icon><Position /></el-icon>发布</el-button
      >
    </el-tooltip>
  </el-button-group>

  <!-- 表格组件 -->
  <TableList
    componentTableId="PbSchoolManagement"
    @update-list="updateList"
    excelName="普本院校管理"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="tableMaxHeight"
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @deleteFnc="deleteFnc"
    @searchFnc="searchFnc"
    @handleSelection="handleSelection"
  >
  </TableList>
  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  >
  </Pagination>
  <!-- 添加编辑 普本院校管理 -->
  <el-dialog
    class="dialogNoPadding"
    :before-close="handleClose"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="850px"
  >
    <AddEditPbSchool
      ref="AddEditComponent"
      v-if="addEditVisible"
      :edit-id="editId"
      :nature-list="natureList"
      :types-list="typesList"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditPbSchool>
  </el-dialog>
  <!-- 普本院校内容 -->
  <!-- <el-dialog v-model="contentVisible" :title="contentdialogTitle" width="1000px">
    <div  class="contentDialog" v-html="decodeURIComponent(contentDetails)"></div>
  </el-dialog> -->
</template>

<script>
import TableList from "components/TableList.vue";
import Pagination from "components/Pagination.vue";
import { reactive, onMounted, toRefs, ref, toRaw } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
import AddEditPbSchool from "views/pbSchoolManagement/AddEditPbSchool.vue";
import {
  getAllSchoolPtNature,
  getAllSchoolPtTypes,
  getPagination,
  removeSchoolPt,
  CreatePbSchoolHtml,
  CreatePbSchoolChannelHtml,
} from "network/pbSchool.js";

export default {
  name: "PbSchoolManagement",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddEditPbSchool,
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },{
          label: "院校名称",
          prop: "name",
          width: "200",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "排序",
          prop: "orderIndex",
          align: "center",
          width: "110",
          noSetText: "未设置",
        },
        {
          label: "所属城市",
          prop: "cityAddress",
          align: "center",
          width: "120",
          noSetText: "未设置",
        },
        {
          label: "院校性质",
          prop: "nature",
          width: "160",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "院校类别",
          prop: "types",
          width: "160",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "热门专业",
          prop: "popularMajor",
          width: "300",
          align: "center",
          noSetText: "未设置",
          isTagArr: true,
        },
        {
          label: "院校特色",
          prop: "features",
          width: "300",
          align: "center",
          noSetText: "未设置",
          isTagArr: true,
        },
        {
          label: "院校地址",
          prop: "address",
          align: "center",
          width: "200",
          noSetText: "未设置",
        },
        {
          label: "创建时间",
          prop: "createTime",
          width: "200",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "操作",
          prop: "operation",
          width: "200",
          align: "center",
          fixed: "right",
          operation: true,
          edit: true,
          delete: true,
        },
      ],
      //筛选项
      search: {
        name: null,
        nature: null,
        types: null,
      },
      natureList: [], //普本院校性质下拉选项
      typesList: [], //普本院校类别下拉选项
      dialogTitle: "添加普本院校",
      addEditVisible: false, //添加编辑弹窗
      contentdialogTitle: "查看普本院校内容",
      contentVisible: false, //普本院校内容弹窗
      contentDetails: "", //普本院校内容
      editId: 0,
      multipleSelection: [], //选中行数据
    });
    //挂载后调用函数获取项目数据
    onMounted(() => {
      getNatureData(); //获取院校性质
      getTypesData(); //获取院校类别
      getpbSchoolData(); //请求普本院校列表数据
    });
    //院校性质
    function getNatureData() {
      getAllSchoolPtNature()
        .then((res) => {
          if (res.code == 1) {
            data.natureList = res.result;
            data.headerData.map((item) => {
              if (item.prop == "nature") {
                item.selectOptions = data.natureList;
              }
            });
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    //院校类别
    function getTypesData() {
      getAllSchoolPtTypes()
        .then((res) => {
          if (res.code == 1) {
            data.typesList = res.result;
            data.headerData.map((item) => {
              if (item.prop == "types") {
                item.selectOptions = data.typesList;
              }
            });
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // 获取列表
    const getpbSchoolData = () => {
      data.loading = true;
      const obj = {
        name: data.search.name,
        nature: data.search.nature,
        types: data.search.types,
        pageNumber: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
      };
      getPagination(obj)
        .then((result) => {
          if (result && result.code == 1) {
            const list = result.result.items;
            data.pagination.total = result.result.allItemsCount;
            const dataList = toRaw(list);
            dataList.forEach((item) => {
              // 转化tags数组为字符串，用于tooltip展示
              // item.featuresString = item.features.join(",");
              const list = toRaw(data.natureList);
              list.forEach((i) => {
                if (i.key == item.nature) {
                  item.nature = i.value;
                }
              });
              const list2 = toRaw(data.typesList);
              list2.forEach((j) => {
                if (j.key == item.types) {
                  item.types = j.value;
                }
              });
            });
            data.tableData = dataList;

            data.loading = false;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "name") {
        data.search.name = val.value;
      }
      if (val.prop && val.prop == "nature") {
        data.search.nature = val.value;
      }
      if (val.prop && val.prop == "types") {
        data.search.types = val.value;
      }
      data.pagination.currentPage = 1;
      getpbSchoolData();
    };

    //更新列表
    const updateList = () => {
      getpbSchoolData();
    };

    // 添加
    const addFnc = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      data.addEditVisible = true;
      data.dialogTitle = "添加普本院校";
      data.editId = 0;
    };

    // 编辑院校
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${obj.name}】院校`;
      data.editId = obj.id;
    };

    // 删除
    const deleteFnc = (obj) => {
      ElMessageBox.confirm(`是否删除[${obj.name}]院校？`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteData(obj.id);
        })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      removeSchoolPt(id)
        .then((result) => {
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };

    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };

    //关闭添加编辑弹窗操作
    const AddEditComponent = ref();
    const handleClose = () => {
      if (data.addEditVisible) {
        AddEditComponent.value.resetForm();
        data.addEditVisible = false;
      }
    };

    // 表格多选行处理
    const handleSelection = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
    };
    //发布
    const releaseFnc = (e) => {
            // 强制移除按钮焦点
      lostFocus(e);
      if (data.multipleSelection == 0) {
        ElMessage.error("请选择需要发布的数据");
        return;
      }
      if (data.multipleSelection.length > 1) {
        ElMessage.error("只能选择一个进行发布");
        return;
      }
      ElMessageBox.confirm(
        `是否将[${data.multipleSelection[0].name}]发布到PC端`,
        "删除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          postCreatePbSchoolHtml(data.multipleSelection[0].id);
        })
        .catch(() => {
          ElMessage("取消发布");
        });
    };
    const postCreatePbSchoolHtml = async (id) => {
      data.loading = true;
      const result1 = await CreatePbSchoolHtml(id);
      const result2 = await CreatePbSchoolChannelHtml(id);
      if (result1.code == 1) {
        data.loading = false;
        ElMessageBox.alert("发布成功", {
          confirmButtonText: "确定",
        });
        updateList();
      } else {
        data.loading = false;
        ElMessageBox.alert(result1.message, {
          confirmButtonText: "确定",
        });
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getpbSchoolData,
      searchFnc,
      updateList,
      addFnc,
      editFnc,
      deleteFnc,
      closeDialog,
      changePagination,
      AddEditComponent,
      handleClose,
      handleSelection,
      releaseFnc,
    };
  },
};
</script>
<style scoped>
.tooltip {
  width: 300px;
}
</style>

